import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { POPUP_DATA } from 'src/app/@shared/services/modal/modal.service';
import { ResizeService } from 'src/app/@shared/services/resize/resize.service';
import { MatDialogRef } from '@angular/material/dialog';
import { ResizeableComponent } from '../../design/resizeable/resizeable.component';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import {
  CLOSE,
  NEXT_IMAGE,
  PREVIOUS_IMAGE,
  STATION_PHOTO_ALT,
} from 'src/app/modules/route-planner/constants/multi-language.constants';

@Component({
    selector: 'app-image-carousel',
    templateUrl: './image-carousel.component.html',
    styleUrls: ['./image-carousel.component.scss'],
    standalone: false
})
export class ImageCarouselComponent
  extends ResizeableComponent
  implements OnInit
{
  images: string[];
  currentIndex = 0;

  /** Localized strings used for image alt and navigation button aria-labels. */
  previousImageText: string = 'Previous image';
  nextImageText: string = 'Next image';
  /**
   * a11y: localized aria-label for the new top close (X) button. The
   * carousel previously had no dedicated close affordance — only prev/next
   * navigation. Required by the audit so every popup has a focusable close
   * target receiving initial focus on open.
   */
  closeText: string = 'Close';
  private altTemplate: string = STATION_PHOTO_ALT.english;

  constructor(
    resizeService: ResizeService,

    private cd: ChangeDetectorRef,

    public dialogRef: MatDialogRef<ImageCarouselComponent>,

    @Inject(POPUP_DATA)
    public readonly popUpData: {
      data: { imagesUrl: string[]; activePhotoIndex?: number };
    },

    private readonly languageService: LanguageService
  ) {
    super(resizeService);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.images = this.popUpData.data.imagesUrl;
    this.currentIndex = this.popUpData.data.activePhotoIndex ?? 0;

    this.languageService.selectedLanguage$.subscribe((language) => {
      this.previousImageText = PREVIOUS_IMAGE[language.language];
      this.nextImageText = NEXT_IMAGE[language.language];
      this.altTemplate = STATION_PHOTO_ALT[language.language];
      this.closeText = CLOSE[language.language];
    });

    this.cd.markForCheck();
  }

  getSlide() {
    return this.images[this.currentIndex];
  }

  /** Localized alt for the currently visible slide so SR users get context. */
  getSlideAlt(): string {
    if (!this.altTemplate) {
      return '';
    }
    return this.altTemplate
      .replace('{0}', String(this.currentIndex + 1))
      .replace('{1}', String(this.images?.length ?? 0))
      .replace('{2}', '');
  }

  getPrev() {
    this.currentIndex =
      this.currentIndex === 0 ? this.images.length - 1 : this.currentIndex - 1;
  }
  
  getNext() {
    this.currentIndex =
      this.currentIndex === this.images.length - 1 ? 0 : this.currentIndex + 1;
  }

  /**
   * a11y: dismiss handler used by the top close (X) button. The carousel is
   * opened via `MatDialog`, not the shared CardDesignComponent flow, so we
   * close through `dialogRef` directly instead of `closeCard`.
   */
  close(): void {
    this.dialogRef.close();
  }
}
